<template>
  <router-view></router-view>
</template>

<script>
// Create this EmptyRouterView to handle route nesting issues.
// https://dev.to/berniwittmann/my-approach-on-vue-router-architecture-and-nested-routes-2kmo

export default {
  name: 'EmptyRouterView'
}
</script>